export const subtitles = {
    "1": {
        "startTime": 9.87,
        "endTime": 15.79,
        "transcript": "Ii-i, qaneryullemnek waniw' qanqatartua makunek",
        "translation": "Okay, I'm going to say what I want about these"
    },
    "2": {
        "startTime": 15.865,
        "endTime": 23.485,
        "transcript": "Waten tan'gaurluullemni, tan'gaurluullemteńi makunek",
        "translation": "These things when I was a boy, when we were boys"
    },
    "3": {
        "startTime": 25.35,
        "endTime": 38.48,
        "transcript": "Makunek-wa tua-i nunam qainganelngurnek neqemteńek, pitarkanek, imarpigmiutaat makut-llu cali yaqulget.",
        "translation": "Our food that we hunt on land, sea animals, and these birds."
    },
    "4": {
        "startTime": 39.75,
        "endTime": 45.73,
        "transcript": "Maa-i mat'um nalliini nang'ut.",
        "translation": "There are no more these days."
    },
    "5": {
        "startTime": 47.725,
        "endTime": 60.275,
        "transcript": "Makut waten imarpigmiutaat enurnaringut, makut-llu yaqulget cali enurnaringluteng.",
        "translation": "These sea animals are becoming scarce, and these birds are also becoming scarce."
    },
    "6": {
        "startTime": 60.785,
        "endTime": 73.465,
        "transcript": "Imumi waten tan'gaurluullemteńi, tan'gaurluullemni-w' tua-i up'nerkami amllepiatullruut yaqulget.",
        "translation": "Back when we were boys, at least when I was a boy, there used to be a great many birds in the spring."
    },
    "7": {
        "startTime": 74.73,
        "endTime": 81.52,
        "transcript": "Yuilquq nepaitellruuq. Waten ayuqellrunrituq.",
        "translation": "The wilderness was quiet. It wasn't like this."
    },
    "8": {
        "startTime": 81.73,
        "endTime": 90.4,
        "transcript": "Tem'ingelriamek waten niicuunata ertaqan, ellami tem'irtellrianek.",
        "translation": "We wouldn't hear anything rumbling like this at dawn, rumbling outside."
    },
    "9": {
        "startTime": 90.69,
        "endTime": 103.57,
        "transcript": "Up'nerkami waten up'nerkiaqameng pavani Akulmi nunanirpak yaqulget ayuqenrilnguut qalrialuteng.",
        "translation": "When they went to spring camps in the spring like this inland in the Akula region, it was wonderful with various birds calling."
    },
    "10": {
        "startTime": 107.775,
        "endTime": 118.825,
        "transcript": "Makut-llu pissulriit waten atakumi atakuara'rqan, atakuaratullruuq kanaqlagcualriit up'nerkillerni pavani.",
        "translation": "And these hunters in the evening when evening was setting, they would spend the evenings hunting muskrats in the spring camps inland."
    },
    "11": {
        "startTime": 119.585,
        "endTime": 126.835,
        "transcript": "Tua-i cingqullagangnaurtut nut'galriarurrluni waten tua-i piciatun.",
        "translation": "They would make loud pops, the air filled with gunshots like this everywhere."
    },
    "12": {
        "startTime": 127.425,
        "endTime": 136.985,
        "transcript": "Makut-wa yaqulget pavani nanvat ceńaitni-ll' up'nerkitullruameng",
        "translation": "And these birds, because they would camp in the spring on the shores of lakes inland"
    },
    "13": {
        "startTime": 137.46,
        "endTime": 142.57,
        "transcript": "Anglanaqluteng yaqulget kuimalriit qalrialuteng.",
        "translation": "It was fun with the swimming birds calling."
    },
    "14": {
        "startTime": 146.38,
        "endTime": 150.83,
        "transcript": "Nunaniqluni tua-i piaqluni up'nerkami.",
        "translation": "It would be wonderful in the spring."
    },
    "15": {
        "startTime": 152.43,
        "endTime": 162.19,
        "transcript": "Qaillun wii umyuarteqaqama pissurnanriiceteng-qaa nang'ut?",
        "translation": "For what reason, when I think about it, are they gone since they don't hunt them anymore?"
    },
    "16": {
        "startTime": 165.325,
        "endTime": 178.235,
        "transcript": "Wangkuta-llu tan'gaurlucuarni cali waten elitnauruterluni: pissungqerrluta makunek yaquleyagarnek.",
        "translation": "We boys also had these lesson: we hunt these little birds."
    },
    "17": {
        "startTime": 179.185,
        "endTime": 181.645,
        "transcript": "Amllepiarluteng cali.",
        "translation": "There were a great many of them too."
    },
    "18": {
        "startTime": 181.7,
        "endTime": 189.06,
        "transcript": "Pitgaquurluki tamakunek yaquleyagarnek pissurnaurtukut.",
        "translation": "We would hunt those little birds with arrows."
    },
    "19": {
        "startTime": 189.735,
        "endTime": 196.715,
        "transcript": "Tamakut-llu pitaput iciw' egcuunaki.",
        "translation": "And, you know, we wouldn't discard what we caught."
    },
    "20": {
        "startTime": 196.88,
        "endTime": 206.88,
        "transcript": "Makut cali nasaurlullraat meqtayagarluki kenirnaurait.",
        "translation": "Also, these girls would pluck their feathers and cook them."
    },
    "21": {
        "startTime": 207.455,
        "endTime": 215.915,
        "transcript": "Tau͡gken cali aanamta imum keniraqluki cali pitaput egcuunaki.",
        "translation": "However, our mother would also cook what we caught without discarding them."
    },
    "22": {
        "startTime": 216.42,
        "endTime": 225.76,
        "transcript": "Waten qigcikluki, makut nunamiutaat neqput kencikluki au͡gkut pitullruit.",
        "translation": "The people back then would respect and revere the food we got from the land like this."
    },
    "23": {
        "startTime": 228.555,
        "endTime": 232.225,
        "transcript": "Mat'um tau͡gken tua-i nalliini qaillun piat?",
        "translation": "Yet what are they doing these days?"
    },
    "24": {
        "startTime": 232.255,
        "endTime": 243.025,
        "transcript": "Makut-llu yup'ut pissuyuirulluki imkut makut yaquleyagaat pitgaquurluki pitulput.",
        "translation": "And our children do not hunt these little birds that we used to shoot arrows at."
    },
    "25": {
        "startTime": 243.445,
        "endTime": 253.225,
        "transcript": "Tayima tua-i tangrrunanrirluteng maani nunam qaingani up'nerkami pissulalput.",
        "translation": "What we used to hunt on the land here are no more to be seen."
    },
    "26": {
        "startTime": 254.15,
        "endTime": 267.03,
        "transcript": "Tuamtellu cali kiagmi tukraqameng napamiutaat amllepiarluteng puyurcivignun it'raluteng.",
        "translation": "And then when those in the trees hatched in the summer, there would be very many entering smoke houses."
    },
    "27": {
        "startTime": 267.475,
        "endTime": 271.665,
        "transcript": "Wangkuta-wa cali maa-i pitgaquurqeput.",
        "translation": "We would also hunt with arrows."
    },
    "28": {
        "startTime": 275.005,
        "endTime": 286.355,
        "transcript": "Amiiyaarluki uuggun qat'gaitgun cilla'arrluki kemgit au͡g'arluki, uuggun-llu yaqruita piitgun ayagciqerluki.",
        "translation": "We skinned the little things, opened them here on their chests, removed their flesh, and propped them on their wings here."
    },
    "29": {
        "startTime": 286.985,
        "endTime": 291.235,
        "transcript": "Nuucirluki-ll' nutaan napamek agarqurluki.",
        "translation": "Then we tied them and hung them in the trees."
    },
    "30": {
        "startTime": 292.515,
        "endTime": 299.635,
        "transcript": "Wagg'uq-qaa nakaculiluki. Tuaten pitullruut.",
        "translation": "They called that nakaculiluki. That's what they did."
    },
    "31": {
        "startTime": 300.34,
        "endTime": 305.59,
        "transcript": "Amllepiarluteng yaquleyagaat cakaniyuunateng.",
        "translation": "There were a great many little birds without any change in population."
    },
    "32": {
        "startTime": 306.36,
        "endTime": 311.36,
        "transcript": "Makut-wa cali aulukesteput",
        "translation": "Also, our caretakers"
    },
    "33": {
        "startTime": 311.655,
        "endTime": 324.885,
        "transcript": "Up'nerkami tua-i ayagluteng yaqulget waten cetunatkameggnun ner'aqluki tua-i neqekluki kayanguit-llu.",
        "translation": "Starting from the spring until the birds went downriver like this, they would eat them as their food source including their eggs."
    },
    "34": {
        "startTime": 325.135,
        "endTime": 330.765,
        "transcript": "Camek niicuunata nangqatalrianek, ikegliinalrianek.",
        "translation": "We wouldn't hear anything about there being no more, or anything depleting."
    },
    "35": {
        "startTime": 330.795,
        "endTime": 339.065,
        "transcript": "Tau͡gaam waten pitullruut: allamiaquaqan cat ukut ikgetaqluteng.",
        "translation": "But this is what happened: every year, something would have low numbers."
    },
    "36": {
        "startTime": 340.545,
        "endTime": 345.375,
        "transcript": "Caaqameng-ll' amllerrluteng, waten ikgeliqetaarluteng.",
        "translation": "And sometimes, there would be a lot, occasionally decreasing."
    },
    "37": {
        "startTime": 345.475,
        "endTime": 349.055,
        "transcript": "Tau͡gaam nangyuunateng, cakaniyuunateng.",
        "translation": "But they wouldn't be gone, wouldn't be affected."
    },
    "38": {
        "startTime": 349.07,
        "endTime": 355.34,
        "transcript": "Amllerrlainarluteng yaqulget imarpigmiutaat-llu.",
        "translation": "There were always a lot of birds and sea animals."
    },
    "39": {
        "startTime": 356.32,
        "endTime": 365.75,
        "transcript": "Tua-i-llu tamakut waten yaqulget up'nerkami nerluki yaavet tua-i neq'ngellerkaanun.",
        "translation": "And then, they would eat those birds like this in the spring until there were fish."
    },
    "40": {
        "startTime": 365.75,
        "endTime": 370.28,
        "transcript": "Cetuameng tau͡gaam taqluki, ayanqigtevkenateng.",
        "translation": "They only stopped when they went downriver, stopped going out to hunt."
    },
    "41": {
        "startTime": 370.57,
        "endTime": 380.08,
        "transcript": "Nuna tua-i yugtairulluku waten Akula, imarpigmi, unani tau͡gaam Kusquqvagmi.",
        "translation": "There was no one left like this in Akula, but [they were] down on the Kuskokwim."
    },
    "42": {
        "startTime": 380.95,
        "endTime": 387.38,
        "transcript": "Neqnun cali cauluteng. Amllepiarluteng call' neqet.",
        "translation": "They turned to the fish. There also a great many fish."
    },
    "43": {
        "startTime": 391.28,
        "endTime": 404.16,
        "transcript": "Tamaaggun-wa kencikellratgun, Agayutem cikiutekngamiki kencikellratgun tua-i amllerrlainartelluki.",
        "translation": "Through there reverence, because they are God's gifts and they revered them, he always kept them at high numbers."
    },
    "44": {
        "startTime": 405.565,
        "endTime": 416.465,
        "transcript": "Maa-i mat'um nalliini umyuangcarqama tamakut, neqrateng tua-i makut neqteng murilkelluki, mulngakluki.",
        "translation": "When I think on that these days, they would watch and be careful about whatever food they had."
    },
    "45": {
        "startTime": 417.16,
        "endTime": 421.99,
        "transcript": "Neq'lipiatullruuq agaani waten tan'gaurlullraullemteńi.",
        "translation": "There used to be a lot of fish across there when we were boys like this."
    },
    "46": {
        "startTime": 423.89,
        "endTime": 427.19,
        "transcript": "Puukaquaqluteng-llu maavet ceńamun.",
        "translation": "They would also bump each other to the riverbank here."
    },
    "47": {
        "startTime": 427.355,
        "endTime": 436.005,
        "transcript": "Kuimarqamta-llu iliini maaggun naw'un puukaraqluteng neqet.",
        "translation": "And sometimes when we were swimming, the fish would bump into us somewhere here."
    },
    "48": {
        "startTime": 437.725,
        "endTime": 446.835,
        "transcript": "Tua-i-llu mat'um nalliini tua-i kencikenriamceteng cat nangengluteng.",
        "translation": "Then these days, since we don't revere them, there are no more of some things."
    },
    "49": {
        "startTime": 448.175,
        "endTime": 450.825,
        "transcript": "Kencikellruit au͡gkut.",
        "translation": "People back then revered them."
    },
    "50": {
        "startTime": 454.395,
        "endTime": 463.355,
        "transcript": "Tuamtellu waten wangkutnun tua-i yugnun atalliniut makut neqput.",
        "translation": "And then, our food sources are evidently connected to us humans."
    },
    "51": {
        "startTime": 463.43,
        "endTime": 473.57,
        "transcript": "Tuamtellu cetuanek makut piaqata inerqurnauraitkut ivraasqevkenata tayim' cetuarcurqata.",
        "translation": "And then during beluga hunting season, they would admonish us against wading in water when they were hunting beluga."
    },
    "52": {
        "startTime": 474.225,
        "endTime": 481.725,
        "transcript": "Maavet ukalirnermun agaantaqamta ivraqaasqevkenata inerquanauraitkut.",
        "translation": "On this side when we were across there, they would admonish us against wading in water."
    },
    "53": {
        "startTime": 482.19,
        "endTime": 489.27,
        "transcript": "Cetuarcurniluki tamakut qaill' pilriit tuaten inerqutullruitkut.",
        "translation": "They would admonish us like that, saying that they were hunting beluga."
    },
    "54": {
        "startTime": 490.595,
        "endTime": 498.075,
        "transcript": "Tua-i-llu mat'um nalliini tayim' nangluteng pissuyuirucamceteng.",
        "translation": "And so, there are no more these days because we don't hunt them anymore."
    },
    "55": {
        "startTime": 498.39,
        "endTime": 509.15,
        "transcript": "Makut-llem yaquleyagaat nangluteng tayima pissurnanriimceteng wangkuta pitgaquurluki.",
        "translation": "And there are no more of these little birds because we're not hunting them with arrows anymore."
    },
    "56": {
        "startTime": 511.214,
        "endTime": 526.025,
        "transcript": "Tau͡gken makut aipaimta kellutestaita amllericangnaqsaaqluki inerquuteksagulluki pissuyuirutevkarluki yaqulget.",
        "translation": "However, our Caucasian counterparts who regulate them are trying to raise bird populations by restricting us from hunting them."
    },
    "57": {
        "startTime": 527.586,
        "endTime": 533.586,
        "transcript": "Makut yaqulget arulairucuitellruit au͡gkut anglicartemta.",
        "translation": "Those who raised us back then didn't stop hunting these birds."
    },
    "58": {
        "startTime": 533.795,
        "endTime": 538.881,
        "transcript": "Tua-i waten pavani up'nerkami neqkerraarluki",
        "translation": "After having them as a food source in the spring inland"
    },
    "59": {
        "startTime": 538.893,
        "endTime": 551.349,
        "transcript": "Tua-i-ll' cali neqnek pirraarluteng imkut tengesciigaliata ingcata piyagaat-llu",
        "translation": "And then, after they fished, when those birds couldn't fly anymore as they molt, and the chicks"
    },
    "60": {
        "startTime": 551.947,
        "endTime": 563.258,
        "transcript": "Irniarit angtateksaguarcata nutaan cali tamakut pissungluki, qayateng imirluki tekirqengnaurtut.",
        "translation": "When their young were the same size, they would start hunting them, returning with full kayaks."
    },
    "61": {
        "startTime": 565.574,
        "endTime": 569.792,
        "transcript": "Cakaniyuunateng-llu ikegliyuunateng.",
        "translation": "And they wouldn't be affected, wouldn't deplete."
    },
    "62": {
        "startTime": 571.178,
        "endTime": 577.022,
        "transcript": "Mat'um tau͡gken tua-i nalliini cat tamangluteng yaquleyagaat-llu.",
        "translation": "Yet these days, there are no more of some things including little birds."
    },
    "63": {
        "startTime": 577.131,
        "endTime": 581.731,
        "transcript": "Wall'u-qaa pissurnanriamceteng piut?",
        "translation": "Or is it because we don't hunt them anymore?"
    },
    "64": {
        "startTime": 583.839,
        "endTime": 588.014,
        "transcript": "Tua-i au͡gna waten qanengssaka pitauq.",
        "translation": "Well, that is all I have to say."
    },
    "65": {
        "startTime": 588.214,
        "endTime": 598.366,
        "transcript": "Kitak' im'u, iciw' ayagalriani, tayim' iciw' ak'a ayagatullratni",
        "translation": "Then, you know, when traveling, you know back when they traveled"
    },
    "66": {
        "startTime": 598.384,
        "endTime": 607.428,
        "transcript": "Iciw' pellaalliaqata wall'u qaill' piaqata, kaingaqameng canek nertullruat yuilqumi?",
        "translation": "You know, should they get lots or something happens, what would they eat in the wilderness when they got hungry?"
    },
    "67": {
        "startTime": 610.342,
        "endTime": 614.108,
        "transcript": "Kaingaqameng-qaa neqkaunateng?",
        "translation": "You mean when they got hungry without food?"
    },
    "68": {
        "startTime": 614.122,
        "endTime": 621.088,
        "transcript": "Yaa, iciw' yuilqumi pellaakata qaillun neqkailkata canek neryugngaat?",
        "translation": "Yes, you know, if they are lost in the wilderness with no food, what can they eat?"
    },
    "69": {
        "startTime": 622.089,
        "endTime": 628.634,
        "transcript": "Qaill' iciw' uksumi wall'u-q' kiagmi wall'u-q' up'nerkami wall'u-q' uksuarmi?",
        "translation": "How would they do it, you know, in the winter or summer or sping or fall?"
    },
    "70": {
        "startTime": 629.445,
        "endTime": 631.123,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "71": {
        "startTime": 634.746,
        "endTime": 648.111,
        "transcript": "Au͡gkut-wa waten alerqutullruitkut tua-i neqkailkumta, arenqiallugeskumta:",
        "translation": "People back then would instruct us like this if we had no food, or were in an unfortunate situation:"
    },
    "72": {
        "startTime": 650.85,
        "endTime": 664.361,
        "transcript": "Neqkaunata pikumta neqengqerrsugngayaaquq waten:",
        "translation": "If we have no food, one can have food like this:"
    },
    "73": {
        "startTime": 666.039,
        "endTime": 675.806,
        "transcript": "Maa-i makut uugnaraat neqkaugut cailkuni yuilqumi, tau͡gaam kenengqerquni.",
        "translation": "These voles are food sources if he has nothing in the wilderness, but only if he has a fire."
    },
    "74": {
        "startTime": 677.037,
        "endTime": 680.481,
        "transcript": "Tamakut tamaa-i neqkauyaaqut.",
        "translation": "Those can actually be food."
    },
    "75": {
        "startTime": 681.248,
        "endTime": 693.237,
        "transcript": "Tau͡gken cali niitetullrulua, makut-gguq qangqiiret anait imkut neqnguut. Tamaa-i tamakut.",
        "translation": "However, I also used to hear that ptarmigan feces can also be eaten as food. Those things."
    },
    "76": {
        "startTime": 693.456,
        "endTime": 703.034,
        "transcript": "Ava-i apeskevnga qaillun neqkailkuneng nerengnaqlerkait.",
        "translation": "You just asked me how they could eat if they had no food."
    },
    "77": {
        "startTime": 703.893,
        "endTime": 711.971,
        "transcript": "Makut uugnaraat uksumi tangrruutuut.",
        "translation": "We see these voles in the winter."
    },
    "78": {
        "startTime": 714.314,
        "endTime": 719.491,
        "transcript": "Tamaa-i tamakut neqkauyaaqut.",
        "translation": "Those can actually be food."
    },
    "79": {
        "startTime": 719.52,
        "endTime": 725.976,
        "transcript": "Tau͡gaam-am cali nerailkuni angu qassaasqevkenaku.",
        "translation": "But also, if he has not eaten in a while, he should never eat raw meat."
    },
    "80": {
        "startTime": 727.756,
        "endTime": 734.597,
        "transcript": "Wall'u ayainanermini akaurrluku-w' tua-i nereksaitellni",
        "translation": "Or as he's traveling, if he hasn't eaten in a long time"
    },
    "81": {
        "startTime": 735.304,
        "endTime": 748.559,
        "transcript": "Waten taluyillruarmek tekiskuni, iciw' imkut can'giicuayagaat alungya'rnek pitullret, angu nerqaasqenritait tamakut.",
        "translation": "If he comes upon a fish trap like this, you know the blackfish fries they call alungyaraat, he should never eat those."
    },
    "82": {
        "startTime": 748.69,
        "endTime": 755.8,
        "transcript": "Elliinek, elliinek pitaqeciqniluku anrutaanun.",
        "translation": "They said that they would kill him through his stomach."
    },
    "83": {
        "startTime": 759.093,
        "endTime": 766.47,
        "transcript": "Una neraicaraq, arcaqertuq tau͡gaam una meqsulleq kiimi.",
        "translation": "Being without food, but it's worse to be thirsty."
    },
    "84": {
        "startTime": 768.167,
        "endTime": 774.163,
        "transcript": "Arenqiallugeskuni ayakuni neqkailkuni meqsukuni",
        "translation": "If one gets into misfortune in his travels and is hungry and thirsty"
    },
    "85": {
        "startTime": 774.176,
        "endTime": 787.327,
        "transcript": "Inerquumaukut taqsuqluta qanikcarmek neresqevkenata meqsungramta.",
        "translation": "We are admonished that if we are tired, not to eat snow even if we're thirsty."
    },
    "86": {
        "startTime": 789.387,
        "endTime": 801.963,
        "transcript": "Qanikcartuaraasqevkenata. Wangkutnek piciqniluta. Ircaqurput pinialiciqniluku tuaten qanikcarmek nerkumta.",
        "translation": "They told us not to eat snow. They said we would kill ourselves. They said our heart would weaken if we ate snow like that."
    },
    "87": {
        "startTime": 803.621,
        "endTime": 817.032,
        "transcript": "Tau͡gken merkailkuni ca imna plastic-aaq maavet iterrluku.",
        "translation": "However, if he does not have water, he should put a plastic bag inside here."
    },
    "88": {
        "startTime": 818.716,
        "endTime": 825.172,
        "transcript": "Puqlami urugcirluku. Tuaten tua-i alerqulallruit.",
        "translation": "They would melt it in warmth. That's how they would instruct them."
    },
    "89": {
        "startTime": 826.649,
        "endTime": 835.004,
        "transcript": "Unani-llu cali imarpigmi tuaten ayuqluni arenqiallugeskuni, merkailkuni.",
        "translation": "That's also how it is down in the ocean if he gets into misfortune without water."
    },
    "90": {
        "startTime": 837.013,
        "endTime": 842.485,
        "transcript": "Pitami anrutaa, iciw' qilua...",
        "translation": "His catch's stomach, you know, its intestines..."
    },
    "91": {
        "startTime": 843.868,
        "endTime": 846.313,
        "transcript": "(Piciatun?) Ai? (Piciatun pitani?)",
        "translation": "(Anything?) What? (Anything he caught?)"
    },
    "92": {
        "startTime": 846.366,
        "endTime": 852.211,
        "transcript": "Ii-i, piciatun pitani tua-i maklaarem imarpigmiutaam qilua.",
        "translation": "Yes, the intestines of whatever he catches, a seal, a sea animal."
    },
    "93": {
        "startTime": 855.058,
        "endTime": 867.592,
        "transcript": "Kepluku qaillun tua-i pitariluku piyugtacimitun maqluku. Un'a imarpik umyuangarrluni mernaituq meq egyungvailgan.",
        "translation": "He should cut it to whatever length he wants and drain it. One should not drink at the first thought down in the ocean before water seeps out."
    },
    "94": {
        "startTime": 868.497,
        "endTime": 877.605,
        "transcript": "Arenqiallugeskuni tamatumek avaqlingqerquni pitangqerquni",
        "translation": "If he gets into misfortune, if there's one of those around him"
    },
    "95": {
        "startTime": 878.61,
        "endTime": 891.122,
        "transcript": "Anrutaa wall' qilua imna takqupak qaill' tua-i taktariluku kepluku maqluku-llu, nutaan-llu qanikcarmek imirluku.",
        "translation": "Cut its stomach or its long intestines into whatever length he wants, drain it, then put snow inside it."
    },
    "96": {
        "startTime": 895.754,
        "endTime": 896.587,
        "transcript": "Ayagninqigteqaa.",
        "translation": "Please start again."
    },
    "97": {
        "startTime": 896.594,
        "endTime": 899.646,
        "transcript": "Ii-i, au͡gna ava-i pilqa",
        "translation": "Okay, about what I was just talking about"
    },
    "98": {
        "startTime": 900.871,
        "endTime": 909.016,
        "transcript": "Imarpigmiutaam qilua maqeqaarluku, tua-i-ll' qanikcarmek imirluku.",
        "translation": "After draining the sea animals intestines, put snow inside it."
    },
    "99": {
        "startTime": 909.814,
        "endTime": 920.792,
        "transcript": "Tua-i-llu-gguq maavet iterrluku puqlami, tau͡gaam kememinun pivkenaku.",
        "translation": "And then, they said to put it into the warm spot here, but not touching his skin."
    },
    "100": {
        "startTime": 920.81,
        "endTime": 925.221,
        "transcript": "Maavet tau͡gaam urugarkauluni waten piluku iquuk qillerrlukek.",
        "translation": "It will melt here, tying its ends like this."
    },
    "101": {
        "startTime": 925.345,
        "endTime": 932.39,
        "transcript": "Tua-i-gguq tuaten unani merkiutuut arenqiallugeskuneng.",
        "translation": "They say that's how they get water down in the ocean if they get into misfortune."
    },
    "102": {
        "startTime": 935.725,
        "endTime": 944.936,
        "transcript": "Maani tau͡gken nunam qaingani tua-i arenqiallugeskuni wall'u kiskuni",
        "translation": "However, if he gets to misfortun here on land or sinks into water"
    },
    "103": {
        "startTime": 950.292,
        "endTime": 961.733,
        "transcript": "Tua-i egmianun nenglliqan aturani nengllingraan piyugngakuni egmian yuuluki kumelqerpailgaki.",
        "translation": "If it's cold, even if it's cold, he should take off his clothes right away if he can before they freeze."
    },
    "104": {
        "startTime": 962.604,
        "endTime": 970.148,
        "transcript": "Makut tua-i aturani ciulaagluki, utumacarluki, all'uki-llu.",
        "translation": "He should quickly wring his clothes to make them better, and put them on."
    },
    "105": {
        "startTime": 970.237,
        "endTime": 982.693,
        "transcript": "Nutaan-llu askuniki canegtangqerqan maakun ekiarakun piluki imirluku.",
        "translation": "And when he puts them on, if there's grass, he should fill and line them."
    },
    "106": {
        "startTime": 983.546,
        "endTime": 986.858,
        "transcript": "Makuk-llu waten unkut.",
        "translation": "Including the area down here."
    },
    "107": {
        "startTime": 988.253,
        "endTime": 1000.62,
        "transcript": "Waten alerquuterluni nenglliqan. Ukuk tau͡gaam waten taptaarturlukek pisqellukuk, ukut-llu waten ukuk.",
        "translation": "This is an instruction when it's cold. But, they are told to continually fold these here, including these like this."
    },
    "108": {
        "startTime": 1003.163,
        "endTime": 1014.059,
        "transcript": "Tau͡gken-gguq-am waten uitaurquni cikuskani tua-i ukuk pektesciigalkagnek amllirasciigatarkauluni.",
        "translation": "However, they said that if he stays still and freezes, when these can't move anymore, he will not be able to walk."
    },
    "109": {
        "startTime": 1014.282,
        "endTime": 1020.737,
        "transcript": "Ukuk-llu cali waten pikagnek tua-i pektesciigatarkauluni.",
        "translation": "And if these also freeze, he won't be able to move."
    },
    "110": {
        "startTime": 1023.228,
        "endTime": 1033.857,
        "transcript": "Alerqulallruitkut tuaten tua-i camek-wa tua-i anirtuuka'rmek nunamteńi piilkumta tuaten pisqelluta.",
        "translation": "They would instruct us to do that if we didn't have anything around us to save us."
    },
    "111": {
        "startTime": 1034.424,
        "endTime": 1041.368,
        "transcript": "Ukuk tua-i waten elliurturaqaqlukek nengelmi, ukuk-llu, ayanrilkumta.",
        "translation": "We should keep doing this with these [arms] in the cold, and these [legs], if we're not moving."
    },
    "112": {
        "startTime": 1044.524,
        "endTime": 1051.132,
        "transcript": "Arenqiallugcaraq amllertuq maani nunam qaingani.",
        "translation": "There are many ways to get into misfortune here on land."
    },
    "113": {
        "startTime": 1051.845,
        "endTime": 1054.778,
        "transcript": "Piyunartacirramitun.",
        "translation": "He should do whatever he can."
    },
    "114": {
        "startTime": 1055.219,
        "endTime": 1058.919,
        "transcript": "Tuamtellu-gguq cali waten alerqutullruitkut:",
        "translation": "And then, they would also instruct us like this:"
    },
    "115": {
        "startTime": 1059.081,
        "endTime": 1069.487,
        "transcript": "Nengelvagmi ayainanemteńi tua-i alqunaq igeskumta",
        "translation": "If we are traveling in the extreme cold and suddenly fall"
    },
    "116": {
        "startTime": 1070.632,
        "endTime": 1079.765,
        "transcript": "Egmian cikum acianun pinrilkumta tangerrluku qamevkenata",
        "translation": "If we do not immediately go under the ice, depending on if we do not sink in"
    },
    "117": {
        "startTime": 1079.858,
        "endTime": 1088.781,
        "transcript": "Iciw' tua-i piqarraarluta piyugnganrilkumta",
        "translation": "You know, after we do that, if we are unable [to do anything else]"
    },
    "118": {
        "startTime": 1089.095,
        "endTime": 1096.201,
        "transcript": "Aliumatvut waten piqerluku nep'artelluku.",
        "translation": "Do this with our glove to make it stick [to the ice]."
    },
    "119": {
        "startTime": 1097.086,
        "endTime": 1103.631,
        "transcript": "Tauna tua-i nepingaurtelluku waten elliuqaqluku.",
        "translation": "Keep that stuck, occassionally doing this."
    },
    "120": {
        "startTime": 1103.642,
        "endTime": 1116.964,
        "transcript": "Tua-i piarkaunriqreskan nutaan tuaggun cayugluku waten nugyugngaarkauluni nugyugngakuni.",
        "translation": "If it would not come off, he will be able to get out of the water by pulling that like this if he is able to come out."
    },
    "121": {
        "startTime": 1120.258,
        "endTime": 1126.291,
        "transcript": "Arenqiallugcaraq una amllertuq qanruyutii.",
        "translation": "There is a lot of traditional wisdom about getting into misfortune."
    },
    "122": {
        "startTime": 1126.374,
        "endTime": 1138.602,
        "transcript": "Arenqiallugeskumta-gguq iciw' tavevkenata, alqunaq-wa tua-i anirtuangnaq'laagesqevkenata.",
        "translation": "They said that if we get into misfortune, you know, not to panic and try to hastily save ourselves."
    },
    "123": {
        "startTime": 1138.858,
        "endTime": 1144.247,
        "transcript": "Pingnaqkumta-gguq wangkutnek pitaqeciqukut.",
        "translation": "They said that if we try [too hastily], we will kill ourselves."
    },
    "124": {
        "startTime": 1144.438,
        "endTime": 1158.981,
        "transcript": "Maani-llu cali mermi, ayagakumta meq man'a murilkelluku anirtuumatkarput.",
        "translation": "And in the water here, when we travel, we should observe the water for what can save us."
    },
    "125": {
        "startTime": 1160.355,
        "endTime": 1168.465,
        "transcript": "Qairet-llu makut cali murilkelluki qaill' atullerkait. Alerqutullruitkut tuaten.",
        "translation": "They also told us to observe how to use these waves. That's how they instructed us."
    },
    "126": {
        "startTime": 1169.53,
        "endTime": 1177.625,
        "transcript": "Tamaaggun tamaa-i murilkellermikun tau͡gaam una temni ayagatarkaugaa.",
        "translation": "He must only physically travel through his being observant."
    },
    "127": {
        "startTime": 1179.048,
        "endTime": 1187.959,
        "transcript": "Ava-i-llu tua-i neqkaicaram ayuqucianek apcaaqerpenga.",
        "translation": "And, you just asked me about being without food."
    },
    "128": {
        "startTime": 1187.975,
        "endTime": 1197.864,
        "transcript": "Tau͡gaam nalluaqa qaillun cakaunani-w' tua-i pillerkaq.",
        "translation": "But I do not know what to do if one does not have anything."
    },
    "129": {
        "startTime": 1198.683,
        "endTime": 1208.189,
        "transcript": "Tau͡gaam aturangqerquni neryugngalriamek qecigmek",
        "translation": "But if he has skin clothes that can be eaten"
    },
    "130": {
        "startTime": 1208.396,
        "endTime": 1216.841,
        "transcript": "Tauna tua-i kenengqerquni eleggluku qassarpek'naku.",
        "translation": "If he has a fire, he should char it, not eat it raw."
    },
    "131": {
        "startTime": 1217.989,
        "endTime": 1224.0,
        "transcript": "Akaureskan nereksaitellni tauna tua-i anirtuatekarkaugaa.",
        "translation": "If he hasn't eaten in a long time, that will save him."
    },
    "132": {
        "startTime": 1224.327,
        "endTime": 1238.322,
        "transcript": "Makut maa-i alerqutullruitkut qangqiiret-gguq makut anait qanikcarmun waten akuarrluki nerellrit cayuitut.",
        "translation": "They would instruct us that it's safe to put ptarmigan feces into the snow and eat it."
    },
    "133": {
        "startTime": 1238.449,
        "endTime": 1243.704,
        "transcript": "Tan'gaurluullteteńi naspaalaratullruaput tamakut.",
        "translation": "We used to try those when we were boys."
    },
    "134": {
        "startTime": 1245.739,
        "endTime": 1252.373,
        "transcript": "Tuaten tua-i ner'aqluki imkut qangqiiret makut anait.",
        "translation": "We would eat ptarmigan feces like that."
    },
    "135": {
        "startTime": 1254.016,
        "endTime": 1259.483,
        "transcript": "Qanikcarmun akuarqaarluki ner'aqluki naspaaluki.",
        "translation": "After putting them in snow, we would try eating them."
    },
    "136": {
        "startTime": 1260.022,
        "endTime": 1263.055,
        "transcript": "Tuaten qanruyutnguan. Ai?",
        "translation": "Because that's traditional wisdom. What?"
    },
    "137": {
        "startTime": 1263.088,
        "endTime": 1264.333,
        "transcript": "Cangateksaunateng?",
        "translation": "Were they okay?"
    },
    "138": {
        "startTime": 1264.347,
        "endTime": 1277.089,
        "transcript": "Assirluteng, cangateksaunateng napaungameng-wa tua-i makut nunam qaingani nunam qainganek neqengqerrameng",
        "translation": "They were good, they were okay, because of these trees, because they eat these trees"
    },
    "139": {
        "startTime": 1278.404,
        "endTime": 1286.742,
        "transcript": "Naumalrianek tumaglinek-llu neqengqerrameng, makunek-ll' ayunek, napat-llu kangritnek.",
        "translation": "Because they eat plants, and lowbush cranberries, and Labrador tea, and the top parts of trees."
    },
    "140": {
        "startTime": 1287.113,
        "endTime": 1298.489,
        "transcript": "Cangacuunateng. Inerquutngunritut tamakut. Camek alingnarqellriartaitut qangqiiret anait.",
        "translation": "They were okay. Those are not admonished against. There's nothing dangerous in ptarmigan feces."
    },
    "141": {
        "startTime": 1299.745,
        "endTime": 1300.701,
        "transcript": "Tua-i.",
        "translation": "That's all."
    },
    "142": {
        "startTime": 1301.898,
        "endTime": 1304.11,
        "transcript": "Camek allamek umyuaqengangqertuten?",
        "translation": "Do you have any other thoughts?"
    },
    "143": {
        "startTime": 1304.121,
        "endTime": 1304.821,
        "transcript": "Ai?",
        "translation": "What?"
    },
    "144": {
        "startTime": 1304.832,
        "endTime": 1308.477,
        "transcript": "Camek allamek umyuaqengangqertuten?",
        "translation": "Do you have any other thoughts?"
    },
    "145": {
        "startTime": 1309.684,
        "endTime": 1312.095,
        "transcript": "Kitak' arulaiqercetqerru.",
        "translation": "Can you stop recording for a while?"
    },
    "146": {
        "startTime": 1314.944,
        "endTime": 1316.677,
        "transcript": "Ayagnirnariuq? (Yaa.)",
        "translation": "Is it time to start? (Yes.)"
    },
    "147": {
        "startTime": 1316.69,
        "endTime": 1326.53,
        "transcript": "Ii-i, tua-ll' waniw' mat'um nalliini niicugnilriani",
        "translation": "Okay, so to you who are listening these days"
    },
    "148": {
        "startTime": 1329.267,
        "endTime": 1334.279,
        "transcript": "Umyuaqelallemnek qanqatartua atullemnek-llu.",
        "translation": "I'm going to speak about what's been on my mind and what I've experienced."
    },
    "149": {
        "startTime": 1337.449,
        "endTime": 1350.732,
        "transcript": "Waten ukut waniw': akerta, erenret-ll' unuakumi akertem ciungani alailallrat, puglallrat",
        "translation": "These things: the sun, and what becomes visible, appears, before the sun in the morning"
    },
    "150": {
        "startTime": 1351.922,
        "endTime": 1360.98,
        "transcript": "Maa-i mat'um nalliini alairqata pugnilaqeput, igvarqata-llu pug'aqluteng.",
        "translation": "When they become visible these days, we say they appear, and they appear when they come into view."
    },
    "151": {
        "startTime": 1361.049,
        "endTime": 1365.772,
        "transcript": "Akerta ikaggun pugtuuq",
        "translation": "The sun rises across there"
    },
    "152": {
        "startTime": 1366.638,
        "endTime": 1378.094,
        "transcript": "Maani tua-i Kusquqviim kanavalirnerani uitakumta.",
        "translation": "If we're here toward the water on the Kuskokwim."
    },
    "153": {
        "startTime": 1378.164,
        "endTime": 1391.858,
        "transcript": "Una-i un'a Kusquqvak unani caningqauq keggaknerem ping'um waten kepluku.",
        "translation": "The Kuskokwim down there is on the side, with the west cutting into it inland."
    },
    "154": {
        "startTime": 1393.411,
        "endTime": 1408.223,
        "transcript": "Arenqiallugeskuni nani maani, wall'u ayuquciireskuni, amirluuskani, pirtunguskani, wall' taitunguskani",
        "translation": "If he gets into misfortune somewhere here, or if he's lost, if it gets cloudy, if a blizzard sets, or gets foggy"
    },
    "155": {
        "startTime": 1409.179,
        "endTime": 1422.029,
        "transcript": "Unukani tua-i, wall'u nanluciitqapiarluni pikuni, nani-ll' Kusquqvak uitacia nallukuniu",
        "translation": "If it's night, or he has absolutely no idea where he is, and he doesn't know where the Kuskokwim is"
    },
    "156": {
        "startTime": 1422.895,
        "endTime": 1425.251,
        "transcript": "Tua-i ayuquciitkacagarluni.",
        "translation": "Being completely lost."
    },
    "157": {
        "startTime": 1426.419,
        "endTime": 1434.002,
        "transcript": "Atullruarput pingayuuluta Negteḿun ayallemteńi.",
        "translation": "Three of us experienced that when we were going to Newtok."
    },
    "158": {
        "startTime": 1435.67,
        "endTime": 1443.858,
        "transcript": "Tau͡gaam murilkelallruaqa mat'um ciungani una akerta iraluq-llu.",
        "translation": "But before this, I used to observe the sun and moon."
    },
    "159": {
        "startTime": 1444.049,
        "endTime": 1452.602,
        "transcript": "Naw'un picuituq. Ikaggun kiaqvaarkun pit'elartuq Kusquqviim akilirnerakun.",
        "translation": "It doesn't rise anywhere else. It rises across there, a ways upriver across the Kuskokwim."
    },
    "160": {
        "startTime": 1452.669,
        "endTime": 1462.808,
        "transcript": "Tua-i-llu qerturivailegmi, quyigivailegmi Kusquqviim quliikun ayagluni.",
        "translation": "And then, before it gets too high, it goes above the Kuskokwim."
    },
    "161": {
        "startTime": 1464.619,
        "endTime": 1468.063,
        "transcript": "Uatmurrluni imarpiim tungiinun.",
        "translation": "It goes downriver toward the ocean."
    },
    "162": {
        "startTime": 1468.16,
        "endTime": 1482.482,
        "transcript": "Tua-i-llu nutaan imarpiim quliinun, imarpimteńun unavet, imarpimta tunglirneranun elliami nutaan pagaavet ellirluni.",
        "translation": "And then when it goes above the ocean, our ocean odown there, toward our ocean, it finally goes up there."
    },
    "163": {
        "startTime": 1482.501,
        "endTime": 1486.134,
        "transcript": "Quyigikanirviirulluni agluni.",
        "translation": "It goes without going any higher."
    },
    "164": {
        "startTime": 1486.169,
        "endTime": 1496.78,
        "transcript": "Tua-i-llu ag'um nunam tunglirneranun piami cali, cali ellurluni nunamun mat'umun ipcarturluni.",
        "translation": "And then when it goes across toward the land, it goes down to disappear on the land here."
    },
    "165": {
        "startTime": 1498.327,
        "endTime": 1506.71,
        "transcript": "Iraluq cali-llu akerta.",
        "translation": "The moon and the sun."
    },
    "166": {
        "startTime": 1506.974,
        "endTime": 1515.59,
        "transcript": "Tuamtellu iciw' Qaluuritmek, nallunritarci. Qaluuritmek pillalriaci.",
        "translation": "And then, you know, the Big Dipper (Qaluurin), you know it. You talk about the Big Dipper."
    },
    "167": {
        "startTime": 1516.51,
        "endTime": 1517.777,
        "transcript": "Nallunritan?",
        "translation": "Do you know it?"
    },
    "168": {
        "startTime": 1518.373,
        "endTime": 1524.84,
        "transcript": "Tauna Qaluurin Tunturyugmek pitullruarput wangkuta. Tunturyuk.",
        "translation": "We used to refer to the Big Dipper as Tunturyuk. Tunturyuk."
    },
    "169": {
        "startTime": 1526.054,
        "endTime": 1539.777,
        "transcript": "Tauna tua-i cali Erenret Iquata eniumaralriatun, caumauralriatun ayuqelaraat.",
        "translation": "It's like Erenret Iquat [?constellation?] points them to a certain direction, like it faces a direction for them."
    },
    "170": {
        "startTime": 1540.234,
        "endTime": 1550.861,
        "transcript": "Tua-i akerta tevirluni pikan murilkeciquci Erenret Iquat caumaluku.",
        "translation": "When the sun sets, you will observe that it faces Erenret Iquat."
    },
    "171": {
        "startTime": 1551.451,
        "endTime": 1561.973,
        "transcript": "Tua-i-llu avaggun ayagluni, agaaggun ayagluni, agaalirnerkun.",
        "translation": "And then it goes over there, goes through the area across there on the other side."
    },
    "172": {
        "startTime": 1562.76,
        "endTime": 1570.26,
        "transcript": "Tua-i-ll' tamaavet imarpilirneq mallgiamiu kanarrluni.",
        "translation": "And then when it gets close to the ocean there, it bends down."
    },
    "173": {
        "startTime": 1570.538,
        "endTime": 1580.504,
        "transcript": "Kanarteqanrakun imkut Erenret agkut alairluteng, tanqigiyarturluni agna akertem tunglirnera.",
        "translation": "As soon as it bends down, Erenret [Iquat] appear, and the area toward the sun brightens."
    },
    "174": {
        "startTime": 1580.625,
        "endTime": 1585.248,
        "transcript": "Tauna tua-i cali cuqyutraq'lallruaqa.",
        "translation": "I also used that to find my bearings."
    },
    "175": {
        "startTime": 1585.277,
        "endTime": 1596.51,
        "transcript": "Tua-ll' tuani, pim, Negteḿek tailuta kampaassarput assiitelliniluni navgumaluni.",
        "translation": "And at that time, you know, as we were coming from Newtok, our compass was bad and broken."
    },
    "176": {
        "startTime": 1596.897,
        "endTime": 1599.508,
        "transcript": "Kiatmurtelliniluta.",
        "translation": "We had apparently gone upriver."
    },
    "177": {
        "startTime": 1600.987,
        "endTime": 1606.832,
        "transcript": "Imarpigmun-llu kanaryukluta tan'geriqatarluku.",
        "translation": "We thought we were going down to the ocean as it was getting dark."
    },
    "178": {
        "startTime": 1611.023,
        "endTime": 1623.067,
        "transcript": "Imarpigmun kanaryuklemteńi uterrluta tumllemteggun nunamun piluta. Nanluciitkacagarluta.",
        "translation": "When we thought we were going to the ocean, we backtracked and went to the land. We had no idea where we were."
    },
    "179": {
        "startTime": 1625.042,
        "endTime": 1631.224,
        "transcript": "Pelatekarluta tua-i inarrluta mecungnaringa'rcan.",
        "translation": "We set up a tent and went to bed as it started getting wet."
    },
    "180": {
        "startTime": 1633.414,
        "endTime": 1647.441,
        "transcript": "Tua-i-llu qavainanemteńi uiga'rtua pelatekaq man'a tanqigceterrlugluni nenglaitellruami-llu.",
        "translation": "And then as we were sleeping, I opened my eyes, and the tent was a little bright, also because it was warm."
    },
    "181": {
        "startTime": 1647.885,
        "endTime": 1654.818,
        "transcript": "Maaten caugartaqa kumlanaku, pakemna tanqigcesnganan'.",
        "translation": "I faced it and found that it was cold, and it seemed bright up there."
    },
    "182": {
        "startTime": 1655.468,
        "endTime": 1668.223,
        "transcript": "Piunga pelatekaq callaneruangqerran tekemnek waten pirraarluku piunga iraluq ingna.",
        "translation": "Because the tent had a little hold, after doing this with my forefinger, I saw that the moon was over there."
    },
    "183": {
        "startTime": 1668.344,
        "endTime": 1671.826,
        "transcript": "Tua-i nutaan ayuqucinglua.",
        "translation": "I finally understood where we were."
    },
    "184": {
        "startTime": 1672.714,
        "endTime": 1676.125,
        "transcript": "Kusquqvak tua-i una'antelliniluni.",
        "translation": "The Kuskokwim was down there."
    },
    "185": {
        "startTime": 1677.648,
        "endTime": 1682.337,
        "transcript": "Uilluta tua-i uisngaluta.",
        "translation": "We woke up."
    },
    "186": {
        "startTime": 1683.579,
        "endTime": 1691.846,
        "transcript": "Tua-i-ll' nanluciicaaqengramta ilagka piagka Kusquqviim tungiinun ayakatarniluta.",
        "translation": "And then, even though we didn't know where we were, I told my companions that we were going to go toward the Kuskokwim."
    },
    "187": {
        "startTime": 1692.506,
        "endTime": 1696.917,
        "transcript": "Tua-i ayagluta Kusquqviim tungiinun.",
        "translation": "So, we went toward the Kuskokwim."
    },
    "188": {
        "startTime": 1699.728,
        "endTime": 1713.627,
        "transcript": "Au͡gna-am cali qemini kuik Qurrlurnanek pitulput, umyuarteqluta tamakuukan elitaqciqniluku.",
        "translation": "Also, that river among the hills that we called Qurrlurnat, we thought that we would recognize it."
    },
    "189": {
        "startTime": 1715.089,
        "endTime": 1719.478,
        "transcript": "Ayainanemteńi-ll' tua-i elitaqiluta.",
        "translation": "And as we went, we recognized things."
    },
    "190": {
        "startTime": 1720.351,
        "endTime": 1729.734,
        "transcript": "Taumek waten alerqutullrukaitkut murilkerrlainarluku ca maani nunam qaingani pekatesqelluta.",
        "translation": "That's why they would instruct us to observing everything on the land as we went."
    },
    "191": {
        "startTime": 1732.034,
        "endTime": 1734.578,
        "transcript": "Nallunairturrlainarluki.",
        "translation": "We should always make them landmarks."
    },
    "192": {
        "startTime": 1734.614,
        "endTime": 1740.403,
        "transcript": "Makut-llu kavirlirraat cuqkurluki.",
        "translation": "Also, we should always find our bearings with these [willows with red bark]."
    },
    "193": {
        "startTime": 1740.537,
        "endTime": 1750.214,
        "transcript": "Nunat-llu tungiit assi'irqan ca imna kingunemteńun elli'irqan, tauna tua-i cuqyuka'aqluku.",
        "translation": "And the things toward land, when it's good, when it goes to our home villages, use those to find our bearings."
    },
    "194": {
        "startTime": 1750.813,
        "endTime": 1758.513,
        "transcript": "Ca-llu cali maani nanvarra'ar qertuuralria-llu tuanlucia nalluvkenaku.",
        "translation": "Also, we should know where ponds or elevated areas are here."
    },
    "195": {
        "startTime": 1759.457,
        "endTime": 1762.491,
        "transcript": "Alerquumatullruukut tuaten.",
        "translation": "That's how we were instructed."
    },
    "196": {
        "startTime": 1762.524,
        "endTime": 1778.824,
        "transcript": "Atam-gguq pitsaqa'artevkenata elitaqkumteggu kingunerput imna assiilengraan tuaggun tua-i tunglirnequcia tuanlucia nalluarkauvkenaku.",
        "translation": "They said that if we happen to recognize it, even when the weather's bad, we will know which direction and where our home villages are."
    },
    "197": {
        "startTime": 1779.306,
        "endTime": 1795.543,
        "transcript": "Taumek murilkerrlainarluta-w' tua-i au͡gkut anglicartemta waten ayagalaasqellrukaitkut. Ca murilkerrlainarluku.",
        "translation": "That's why those who raised us back then would tell to always be observant as we traveled like this. We should always observe everything."
    },
    "198": {
        "startTime": 1796.868,
        "endTime": 1807.131,
        "transcript": "Avairqan-ll' unugmi agyat pagkut nallunairturturluki tuanlucia.",
        "translation": "And when it gets clear at night, mark where the stars above are."
    },
    "199": {
        "startTime": 1807.156,
        "endTime": 1819.143,
        "transcript": "Wall'u nuna cali tunglirnerani tauna agyaq uitakan, tuani tua-i taukumiut tuantarkauluteng.",
        "translation": "Or if a star is in the direction of a village, that village will be [marked as being] there."
    },
    "200": {
        "startTime": 1819.593,
        "endTime": 1824.656,
        "transcript": "Tau͡gaam cali enemeggni uitaurayuunateng.",
        "translation": "But, they also wouldn't stay in their houses all the time."
    },
    "201": {
        "startTime": 1824.693,
        "endTime": 1837.856,
        "transcript": "Cuqluku ayagarkauluni nateqsigikaniraqluni tauna agyat tuaten ayalria cuq'errnguarluku.",
        "translation": "They would gauge it when traveling in a certain dirionction, using those stars to get their bearings like that."
    },
    "202": {
        "startTime": 1837.981,
        "endTime": 1842.756,
        "transcript": "Tuaten tua-i wangkuta atullruarput.",
        "translation": "We experienced it like that."
    },
    "203": {
        "startTime": 1843.687,
        "endTime": 1848.375,
        "transcript": "Kiituan elitaqillerkamteńun tekilluta.",
        "translation": "We eventually reached placed we recognized."
    },
    "204": {
        "startTime": 1848.45,
        "endTime": 1851.975,
        "transcript": "Ayallemteńi-llu cali taiciryaaqluni.",
        "translation": "And it was even foggy when we traveled."
    },
    "205": {
        "startTime": 1852.019,
        "endTime": 1865.631,
        "transcript": "Tau͡gaam tuaggun iralukun Kusquqviim tunglirnequcia nalluvkenaku.",
        "translation": "But with that moon, I knew which way the Kuskokwim was."
    },
    "206": {
        "startTime": 1866.169,
        "endTime": 1876.644,
        "transcript": "Qanrullukek-ll' ilagka waten: tua-i uquiruskumta piyuagurluta Kusquqvagmun unavet ayagciqniluta.",
        "translation": "And I told my companions this: if we run out of fuel, we will walk down to the Kuskokwim."
    },
    "207": {
        "startTime": 1877.975,
        "endTime": 1882.113,
        "transcript": "Amta-ll' cataunani Kusquqvak taiciami.",
        "translation": "And yet the Kuskowkim was gone because it was foggy."
    },
    "208": {
        "startTime": 1882.326,
        "endTime": 1886.126,
        "transcript": "Tengssuutmun tangerciqniluta unani...",
        "translation": "I said a plane would see us down..."
    }
};